import { IconButton, SxProps, Theme } from "@mui/material";
import Image from "next/image";
import { darken, useTheme } from "@mui/material/styles";
import React from "react";

type IconButtonVariant = "primary" | "secondary";

interface CommonIconButtonProps {
    width?: number | string;
    height?: number | string;
    icon?: React.ReactNode;
    src?: string;
    size?: number;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    variant?: IconButtonVariant;
    onlyIcon?: boolean;
    sx?: SxProps<Theme>;
    disabled?: boolean;
}

const CommonIconButton: React.FC<CommonIconButtonProps> = ({
    width,
    height,
    icon,
    src,
    size = 15,
    onClick,
    variant = "secondary",
    onlyIcon = false,
    sx,
    disabled
}) => {
    // ============= Hooks =============
    const theme = useTheme();
    const isPrimary = variant === "primary";
    return (
        <IconButton
            onClick={onClick}
            disabled={disabled}
            sx={{
                borderRadius: "8px",
                p: "6px",
                width: width ?? "40px",
                height: height ?? "40px",

                ...(onlyIcon
                    ? {
                        backgroundColor: "transparent",
                        border: "none",
                        color: theme.palette.custom.black,
                        "&:hover": {
                            backgroundColor: theme.palette.action.hover,
                        },
                    }
                    : {
                        backgroundColor: isPrimary
                            ? theme.palette.primary.main
                            : theme.palette.custom.white,
                        color: isPrimary
                            ? theme.palette.custom.white
                            : theme.palette.custom.black,
                        border: `1px solid ${theme.palette.border.light}`,
                        "&:hover": {
                            backgroundColor: isPrimary
                                ? darken(theme.palette.primary.main, 0.1)
                                : darken(theme.palette.custom.white, 0.02),
                        },
                    }),

                ...sx,
            }}
        >
            {icon ? (
                icon
            ) : src ? (
                <Image src={src} width={size} height={size} alt="icon" />
            ) : null}
        </IconButton>
    );
};

export default CommonIconButton;
